import { DateTime, Settings } from 'luxon'
Settings.defaultZoneName = 'Europe/Moscow'

export { DateTime }
